import moment from "moment";

function submissionTime(claim) {
  const value = claim.UpdatedDate;
  if (!value) return Infinity;
  const date = moment(value, [
    moment.ISO_8601,
    "YYYY-MM-DD HH:mm:ss.SSS",
    "YYYY-MM-DD HH:mm:ss",
    "DD/MM/YYYY",
    "DD-MM-YYYY",
    "D MMM YYYY",
    "DD-MMM-YYYY"
  ], "en", true);
  return date.isValid() && date.year() > 1 ? date.valueOf() : Infinity;
}

export function compareClaimSubmission(a, b, key = "UpdatedDate") {
  if (key !== "UpdatedDate") return null;
  const first = submissionTime(a);
  const second = submissionTime(b);
  return first === second ? 0 : first < second ? -1 : 1;
}

export function sortClaimsFifo(claims) {
  return claims.slice().sort((a, b) => compareClaimSubmission(a, b));
}



// WEBPACK FOOTER //
// ./src/services/claimOrder.js